export const modalAddProjectSubTitle = "Inserisci il nome del progetto";
export const modalAddTopicSubTitle = "Inserisci i dati del topic";
export const modalAddTopicTitle = "Aggiungi topic";
export const modalAddUserSubTitle = "Inserisci i dati e il ruolo dell’utente";
export const modalAddUserTitle = "Aggiungi utente";
export const modalConfirmDeleteData = "Elimina Dati";
export const modalConfirmDeleteDataSourceSubtitlePart1 =
  "Sei sicuro di voler eliminare la fonte “";
export const modalConfirmDeleteDataSourceSubtitlePart2 =
  "”? Gli utenti non potranno più accedervi.";
export const modalConfirmDeleteProjectSubtitlePart1 =
  "Sei sicuro di voler eliminare il progetto “";
export const modalConfirmDeleteProjectSubtitlePart2 =
  "”? Gli utenti non potranno più accedervi.";
export const modalConfirmDeleteProjectTitle = "Elimina progetto";
export const modalConfirmDeleteSource = "Rimuovi fonte";
export const modalConfirmDeleteTopic = "Elimina topic";
export const modalConfirmDeleteTopicSubtitlePart1 =
  "Sei sicuro di voler eliminare il topic “";
export const modalConfirmDeleteTopicSubtitlePart2 =
  "”? Gli utenti non potranno più accedervi.";
export const modalConfirmDeleteUser = "Elimina utente";
export const modalConfirmDeleteUserSubtitle =
  "Sei sicuro di voler eliminare questo utente?";
export const modalConfirmLeaveProjectSubTitlePart1 =
  "Sei sicuro di voler abbandonare il progetto “";
export const modalConfirmLeaveProjectSubTitlePart2 =
  "“? Non potrai più accedere fino a nuovo invito.";
export const modalConfirmLeaveProjectTitle = "Abbandona il progetto";
export const modalConfirmLogoutSubtitle = "Verrai reindirizzato alla login";
export const modalConfirmLogoutTitle = "Sicuro di voler uscire?";
export const modalConfirmUpdatesNotSaved =
  "Le modifiche non salvate andranno perse";
export const modalConfirmRemoveAllResponseSubTitle =
  "Sei sicuro di voler rimuovere la risposta selezionata? Le informazioni saranno comunque presenti in chat.";
export const modalConfirmRemoveAllResponseTitle = "Rimuovi risposta";
export const modalConfirmRemoveAllResponsesSubTitle =
  "Sei sicuro di voler rimuovere le risposte selezionate? Le informazioni saranno comunque presenti in chat.";
export const modalConfirmRemoveAllResponsesTitle = "Rimuovi risposte";
export const modalEditProjectSubTitle = "Inserisci il nome del progetto";
export const modalEditProjectTitle = "Rinomina progetto";
export const modalEditSourceSubTitle = "Modifica le informazioni";
export const modalEditSourceTitle = "Modifica fonte privata";
export const modalNewProjectTitle = "Nuovo progetto";
export const modalEditTopicTitle = "Modifica topic";
export const modalEditTopicSubTitle = "Modifica i dati del topic";
export const modalRemoveUserTitle = "Rimuovi utente";
export const modalShareProjcetSubtitle =
  "Scegli con quali utenti condividere il progetto";
export const modalShareAnswerSubtitle =
  "Inserisci la mail di uno o più utenti con cui vuoi condividere la risposta";
export const modalShareAnswersSubtitle =
  "Inserisci la mail di uno o più utenti con cui vuoi condividere le risposte";
export const modalShareProjectSubtitle = "Sei sicuro di voler rimuovere ";
export const modalShareProjectTitle = "Condividi progetto";
export const modalSourcePrivateTitle = "Aggiungi fonte privata";
export const modalSourceSubTitle = "Carica un file e aggiungi le informazioni";
export const modalSourceTitle = "Aggiungi fonte";
export const modalUpdatePasswordTitle = "Modifica password";
export const modalUpdatePasswordSubtitle = "Scegli la tua nuova password";
export const modalDeleteAccount = "Elimina Account";
export const modalDeleteAccountSubtitlePart1 =
  "Sei sicuro di voler eliminare questo account?";
export const modalDeleteAccountSubtitlePart2 =
  "Inserisci la password per confermare";
export const modalDeleteInProgress = "Eliminazione in corso";
export const modalDeleteInProgressSubtitle = "Verrai reindirizzato alla login";
export const modalUpdateUserTitle = "Modifica utente";
export const modalUpdateUserSubTitle = "Modifica i dati e il ruolo dell’utente";
export const modalResolveReportTitle = "Come valuteresti la risposta dell’AI?";
export const modalResolveReportSubTitle =
  "Risolvi la segnalazione scegliendo un’opzione";
export const modalCardResolutionTypeTitleCorrect = "Corretta";
export const modalCardResolutionTypeTitleWrong = "Completamente errata";
export const modalCardResolutionTypeTitlePartiallyWrong = "In parte errata";
export const modalCardResolutionTypeSubTitleCorrect =
  "La risposta continuerà ad essere mostrata e la segnalazione verrà archiviata.";
export const modalCardResolutionTypeSubTitleWrong =
  "La risposta non verrà più mostrata e la segnalazione verrà archiviata.";
export const modalCardResolutionTypeSubTitlePartiallyWrong =
  "La risposta necessiterà di correzioni prima di archiviare la segnalazione.";
export const modalCardResolutionTypeHelpTextCorrect =
  "Non c’è bisogno di nessuna azione ulteriore. ";
export const modalCardResolutionTypeHelpTextWrong =
  "Non c’è bisogno di nessuna azione ulteriore. ";
export const modalCardResolutionTypeHelpTextPartiallyWrong =
  "Dovrai modificare la risposta in modo da renderla corretta.";
export const modalConfirmUpdatStatusReportTitle = "Salvare le modifiche?";
export const modalConfirmUpdatStatusReportSubtitle =
  "Sei sicuro di voler confermare l’operazione? La segnalazione verrà archiviata e non potrai più modificarla.";
export const modalResolvePartiallyEditSubtitle =
  "Modifica il testo della risposta e poi salva per renderlo subito disponibile";
export const modalSendFeedbackTitle = "Fornisci un feedback aggiuntivo";
export const modalSendFeedbackSubTitle =
  "I nostri editor utilizzeranno il tuo commento per migliorare la nostra AI";
export const modalEditPinnedAnswerTitle = "Rinomina risposta salvata";
export const modalEditPinnedAnswerSubTitle =
  "Inserisci il nome della risposta salvata";
export const modalEditInfo = "Modifica dati";
